import { render, staticRenderFns } from "./ProductLifeMngtSolution.vue?vue&type=template&id=fe8773f2&scoped=true"
import script from "./ProductLifeMngtSolution.vue?vue&type=script&lang=js"
export * from "./ProductLifeMngtSolution.vue?vue&type=script&lang=js"
import style0 from "./ProductLifeMngtSolution.vue?vue&type=style&index=0&id=fe8773f2&prod&lang=scss&scoped=true"
import style1 from "./ProductLifeMngtSolution.vue?vue&type=style&index=1&id=fe8773f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8773f2",
  null
  
)

export default component.exports